var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tower-show-page",attrs:{"id":"towerInfo"}},[_c('iframe',{staticStyle:{"border":"0","height":"99%"},attrs:{"id":"iframe","width":"100%","allowfullscreen":"true","src":_vm.myURL,"frameborder":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }